module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "otp-wrapper"
  }, [_c('div', {
    staticClass: "otp-input-group"
  }, _vm._l((_vm.digits), function(digit, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.digits[index]),
        expression: "digits[index]"
      }],
      key: index,
      ref: "otpInputs",
      refInFor: true,
      staticClass: "otp-digit",
      class: {
        bounce: _vm.bounceStates[index], shake: _vm.shakeStates[index]
      },
      attrs: {
        "type": "text",
        "maxlength": 1,
        "inputmode": 'numeric',
        "pattern": '[0-9]*',
        "autofocus": index === 0,
        "autocomplete": "new-password"
      },
      domProps: {
        "value": (_vm.digits[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.digits,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.digits[index] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }, function($event) {
          _vm.handleInput($event, index)
        }],
        "keydown": function($event) {
          _vm.handleKeydown($event, index)
        },
        "paste": _vm.handlePaste,
        "focus": function($event) {
          _vm.handleFocus($event)
        }
      }
    })
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12a5c010", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a5c010","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/otp.vue
// module id = 2038
// module chunks = 0